<script>
	import { Collapse } from "@sveltestrap/sveltestrap";

	export let title = "Untitled";
	export let isOpenDefault = false;
	export let customClass = "";

	let isOpen = isOpenDefault;

	function toggle() {
		isOpen = !isOpen;
	}
</script>

<div class={`card-box ${customClass}`}>
	<div class="header" on:click={toggle}>
		<strong>{title}</strong>
		<span class="chevron">
			{#if isOpen}
				<div>
					<img
						src="/assets/icon-chevron-up.png"
						alt="chevron-up"
						style="width: 18px; height: 18px; display: flex; align-items: center;"
					/>
				</div>
			{:else}
				<div style="width: 18px; height: 22px;">
					<img
						src="/assets/icon-chevron-down.png"
						alt="chevron-down"
						style="width: 18px; height: 18px; display: flex; align-items: center;"
					/>
				</div>
			{/if}
		</span>
	</div>

	<Collapse {isOpen}>
		<div class="body-content">
			<slot />
		</div>
	</Collapse>
</div>

<style>
	.card-box {
		background: white;
		border: 1px solid #eee;
		border-radius: 12px;
		padding: 16px 24px;
		width: 100%;
		box-sizing: border-box;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
		font-weight: bold;
		color: #0a0a1f;
		font-size: 16px;
	}

	.chevron {
		display: flex;
		align-items: center;
	}

	.body-content {
		margin-top: 20px;
	}

	:global(.collapse.show) {
		overflow: visible !important;
	}
</style>
